/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
} from './ScreenerGeneratedDocumentType';
import type { UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner } from './UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner';
import {
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON,
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped,
    UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON,
} from './UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner';

/**
 * 
 * @export
 * @interface UploadExternalEhrDocumentsRequest
 */
export interface UploadExternalEhrDocumentsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_insurance_eligibility_check_results?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_clinic_package?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_full_clinic_package?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    clinic_package_document_ids?: Array<string>;
    /**
     * 
     * @type {Array<ScreenerGeneratedDocumentType>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_generated_document_types?: Array<ScreenerGeneratedDocumentType>;
    /**
     * 
     * @type {Array<UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_generated_document_instances?: Array<UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_additional_document_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    esign_request_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    esign_push_source?: UploadExternalEhrDocumentsRequestEsignPushSourceEnum;
    /**
     * MatrixCare Home Health DocumentTypeUploadID (GUID from the MC HH
     * lookups response). Required when external_ehr_type is
     * MATRIX_CARE_HOME_HEALTH; applied to every doc in this upload batch.
     * 
     * @type {string}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    matrix_care_home_health_document_type_id?: string;
}


/**
 * @export
 */
export const UploadExternalEhrDocumentsRequestEsignPushSourceEnum = {
    Manual: 'manual',
    SystemAuto: 'system_auto'
} as const;
export type UploadExternalEhrDocumentsRequestEsignPushSourceEnum = typeof UploadExternalEhrDocumentsRequestEsignPushSourceEnum[keyof typeof UploadExternalEhrDocumentsRequestEsignPushSourceEnum];


/**
 * Check if a given object implements the UploadExternalEhrDocumentsRequest interface.
 */
export function instanceOfUploadExternalEhrDocumentsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UploadExternalEhrDocumentsRequestFromJSON(json: any): UploadExternalEhrDocumentsRequest {
    return UploadExternalEhrDocumentsRequestFromJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadExternalEhrDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'push_insurance_eligibility_check_results': !exists(json, 'push_insurance_eligibility_check_results') ? undefined : json['push_insurance_eligibility_check_results'],
        'push_clinic_package': !exists(json, 'push_clinic_package') ? undefined : json['push_clinic_package'],
        'push_full_clinic_package': !exists(json, 'push_full_clinic_package') ? undefined : json['push_full_clinic_package'],
        'clinic_package_document_ids': !exists(json, 'clinic_package_document_ids') ? undefined : json['clinic_package_document_ids'],
        'push_generated_document_types': !exists(json, 'push_generated_document_types') ? undefined : ((json['push_generated_document_types'] as Array<any>).map(ScreenerGeneratedDocumentTypeFromJSON)),
        'push_generated_document_instances': !exists(json, 'push_generated_document_instances') ? undefined : ((json['push_generated_document_instances'] as Array<any>).map(UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON)),
        'push_additional_document_ids': !exists(json, 'push_additional_document_ids') ? undefined : json['push_additional_document_ids'],
        'esign_request_id': !exists(json, 'esign_request_id') ? undefined : json['esign_request_id'],
        'esign_push_source': !exists(json, 'esign_push_source') ? undefined : json['esign_push_source'],
        'matrix_care_home_health_document_type_id': !exists(json, 'matrix_care_home_health_document_type_id') ? undefined : json['matrix_care_home_health_document_type_id'],
    };
}

export function UploadExternalEhrDocumentsRequestToJSON(value?: UploadExternalEhrDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'push_insurance_eligibility_check_results': value.push_insurance_eligibility_check_results,
        'push_clinic_package': value.push_clinic_package,
        'push_full_clinic_package': value.push_full_clinic_package,
        'clinic_package_document_ids': value.clinic_package_document_ids,
        'push_generated_document_types': value.push_generated_document_types === undefined ? undefined : ((value.push_generated_document_types as Array<any>).map(ScreenerGeneratedDocumentTypeToJSON)),
        'push_generated_document_instances': value.push_generated_document_instances === undefined ? undefined : ((value.push_generated_document_instances as Array<any>).map(UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON)),
        'push_additional_document_ids': value.push_additional_document_ids,
        'esign_request_id': value.esign_request_id,
        'esign_push_source': value.esign_push_source,
        'matrix_care_home_health_document_type_id': value.matrix_care_home_health_document_type_id,
    };
}

